import Linkify from 'react-linkify'

import { Comment } from '@/gen/inventory/v1/comment_pb'

import { Hyperlink } from '@/components/lemmala-design-system/link/hyperlink'

type CommentCardProps = {
  comment: Comment
}

export const CommentCard = ({ comment }: CommentCardProps) => {
  return (
    <div>
      <div className='whitespace-pre-wrap'>
        <Linkify
          componentDecorator={(href, text, key) => (
            <Hyperlink href={href} key={key}>
              {text}
            </Hyperlink>
          )}
        >
          {comment.body}
        </Linkify>
      </div>
    </div>
  )
}
